export const environment = {
  appTitle:'Drivia',
  isGoawake:false,
  companyName:'Drivia',
  creareName:'Drivia',
  userNameCreare:'Creare',
  urlCreareWebsite: ' ',
  logo:'assets/assets-third/drivia/images/logo.png',
  urlApi:'https://api.drivia.cl/api/',
  urlCommandsApi:'https://api.drivia.cl/commands',
  urlFocusRedis: 'http://redis.drivia.cl',
  orFrotalog:' ',
  domain:'app.drivia.cl',
  defaultUserImg:'assets/assets-third/drivia/images/user_default.png',
  notFoundImg:'https://objectstorage.sa-saopaulo-1.oraclecloud.com/n/grkocmhf7oyf/b/GoAwakePublicObjects/o/image-not-found.png',
  jsonLink: 'https://objectstorage.sa-saopaulo-1.oraclecloud.com/n/grkocmhf7oyf/b/GoAwakePublicObjects/o/ABRANGENCIA_PERIMETRO_SVAA_16-06-2020.geojson',
  recaptchaSitekey:'6LeumyYrAAAAAGXrLbVIf8gYcfHnuf6rqdm1L7CG',
  production:true,
  nodeEnv: 'production',
  urlTelemetry: 'https://api.drivia.cl/telemetry',
  urlEvents: '',
  alarmTypesRequiredFatigueMedias:'1,2,3,4,5,6,7,8,9',
  emailEvents: '',
  loginRoute: 'drivia',
  loginUrl: 'https://login.drivia.cl/',
  allowedAccessList: '8,1,37',
  satelliteMapApi: 'https://tiles.mapquest.com/render/latest/satellite/{z}/{x}/{y}/256/png',
  defaultMapApi: 'https://osm.drivia.cl/tiles/{z}/{x}/{y}.png',
  baseUrl: 'https://app.drivia.cl',
  idleTimeOutMinutes: 30,
  idleSkipPaths: ["/pages/ui-alarms/bi#BI","/pages/ui-alarms/fatigue-v2","/pages/ui-alarms/trips/control-panel#CONTROLPANEL","/pages/operational_map#OPERATION","/pages/positions_by_fences"],
  userTypeTreatment: ["(Central)","(Conclusion)"],
  fenceApiUrl: 'https://api.drivia.cl/core/fences/api/',
  fenceApiKey: 'QXBpIEZlbmNlcw==',
  urlCoreApi: 'https://api.drivia.cl/core/',
  urlCoreFront: 'https://app.drivia.cl/core/',
  apikey: 'QXBpIEtleSBUZWxlbWV0cnk=',

  equipmentsTypeIdWithoutMedia: '5,9' ,
  ambiparDealerId: 'undefined',
  customTemplateEmailCustomerIds: ["",""],
  operationMapUrl: 'https://app.drivia.cl/bus-map/',
  vecchCodelcoApiUrl: 'https://app.drivia.cl/bus-api/',
  gobusProgVsRealBff: 'https://api.drivia.cl/trips',
  urlBusRoute: 'https://app.drivia.cl/bus-route/#/',
  urlRoutes: 'https://app.drivia.cl/routes/',
  urlFences: 'https://app.drivia.cl/fences/',
  googleMapsKey: 'AIzaSyAEkPxJ9uL9Hc5uE1FWoUcepOqlq1u1GAs',
  coreTripsFrontendUrl: 'https://app.drivia.cl/trips',
  customersWithCustomTranslation: 'undefined',
  streamingExpirationTime: '600000',
  isVecch: 'false'
};
